"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const permission_service_1 = require("./permission.service");
const branding_service_1 = require("./branding.service");
let AdminComponent = class AdminComponent {
    constructor(_permission, _admin, _title, _branding) {
        this._permission = _permission;
        this._admin = _admin;
        this._title = _title;
        this._branding = _branding;
        //declarations
        this.initBandaid = true;
        this.tabsetOpen = {
            user: false,
            organization: false,
            clients: false,
            permissions: false,
            demandPartners: false,
            sizes: false,
            massUpdate: false,
            notifications: false,
            cdnPurge: false,
            connectManagement: false
        };
        this._title.setTitle(this._branding.getProductSuiteTitle());
    }
    ngOnInit() {
        this.permission = this._permission.get();
        if (this._admin.getAdminTab()) {
            this.tabsetOpen[this._admin.getAdminTab()] = true;
        }
    }
    openTab(tab) {
        Object.keys(this.tabsetOpen).forEach(key => {
            if (this.tabsetOpen[key]) {
                this._admin.setAdminTab(key);
            }
        });
    }
};
exports.AdminComponent = AdminComponent;
exports.AdminComponent = AdminComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-admin',
        templateUrl: 'app/admin.component.html',
        styleUrls: ['styles/admin.component.css']
    }),
    __metadata("design:paramtypes", [permission_service_1.PermissionService,
        admin_service_1.AdminService,
        platform_browser_1.Title,
        branding_service_1.BrandingService])
], AdminComponent);
//# sourceMappingURL=admin.component.js.map